import { createSlice } from "@reduxjs/toolkit";
import { updateViewList } from "@reducers/_utils/reducer-helpers";

const initialState = {
  live: [],
  expired: [],
  liveTotal: 0,
  expiredTotal: 0,
  promotionTypes: [],
};

const promotionsSlice = createSlice({
  name: "promotions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ADD_PROMOTION_ITEM", (state, action) => {
        const status = action.status;
        state[status] = [action.itemDetails, ...state[status]];
        if (status === "live") {
          state.liveTotal = state.liveTotal + 1;
        } else {
          state.expiredTotal = state.expiredTotal + 1;
          state.liveTotal = state.liveTotal - 1;
        }
      })
      .addCase("UPDATE_PROMOTION_ITEM", (state, action) => {
        const keyLookUp = "grpid";
        const itemDetails =
          action.updateAction === "update" ? action.itemDetails : null;
        state[action.setSelected] = updateViewList(
          keyLookUp,
          action.itemDetails[keyLookUp],
          state[action.setSelected],
          itemDetails
        );
      })
      .addCase("SET_PROMOTIONS", (state, action) => {
        state[action.setSelected] = action.promotions;
        if (action.setTotal) {
          state[action.setTotal] = action.total;
        }
      });
  },
});

export const selectPromotions = (state) => state.promotions;

export default promotionsSlice.reducer;
